// Where the device control plane answers, in a file that imports nothing.
//
// SPLIT OUT OF routes.ts ON 2026-08-29, WHICH IS THE THIRD TIME THIS MOVE HAS
// BEEN MADE IN THIS SERVICE AND THE FIRST TIME IT FIXED SOMETHING THAT WAS
// ALREADY BROKEN.
//
// auth/endpoints.ts went first and its header names the shape: "rateLimit.ts has
// to name these urls in order to limit them, and routes.ts has to read `clientIp`
// out of rateLimit.ts, and those two imports in one pair of files is a cycle
// whose failure depends on evaluation order." kiosk/endpoints.ts followed for the
// same reason. reports/endpoints.ts followed for a different one — so that a
// browser could import a url without importing Fastify.
//
// identity/routes.ts had BOTH problems and neither had been separated out.
// rateLimit.ts imports ADMIN_ENDPOINTS from it, so the cycle auth/endpoints.ts
// was written to avoid exists here today; it survives only because nothing in
// this file's module body runs at import time. And xp/console needs the enrolment
// code url, which it could not have without pulling Fastify, node:crypto, the
// device trust and the whole enrolment reader into a browser bundle.
//
// So the constant moved and routes.ts re-exports it, on reports/endpoints.ts's
// precedent: one spelling, several readers, and no way for a caller to ask for a
// url the service does not answer on.

/**
 * The two operations that decide which tablets exist.
 *
 * Not in the frozen contract, because no device calls them: they are the admin
 * surface, and identity.ts froze the conversation a device has.
 *
 * SEPARATE FROM admin/endpoints.ts's PEOPLE_ENDPOINTS, and that file's header
 * explains the split from the other side: those six are about people and five of
 * them run on a session, these two are the device control plane. The credential
 * differed, and a single object would have invited gating them all the same way.
 *
 * That distinction blurred on 2026-08-29, when `issueEnrolmentCode` gained a
 * session path beside the admin token, and the two objects are kept apart anyway.
 * The reason has outlived the credential: these two urls are rate-limited as a
 * pair and are registered by a different call from a different module, and
 * merging them now would be merging on a similarity that is one commit old.
 */
export const ADMIN_ENDPOINTS = {
  /**
   * Issue a code a crew member types into a tablet.
   *
   * XP_ADMIN_TOKEN, or a signed-in nova_admin presenting a current authenticator
   * code as `second_factor_code`. See auth/freshFactor.ts for why the second
   * exists and identity/routes.ts's `permitted` for how the two are ordered.
   */
  issueEnrolmentCode: "/v1/admin/enrolment-codes",
  /** Stop accepting a tablet. XP_ADMIN_TOKEN alone; routes.ts says why it did not move. */
  revokeDevice: "/v1/admin/devices/revoke",
} as const;
